import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowRightSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12.293 16.293-.707.708L13 18.414l.707-.707 5-5.006.706-.707-.707-.707-5-4.995-.708-.706L11.586 7l.707.706L15.59 11H4.211v2h11.371l-3.29 3.293Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowRightSharp);
export default Memo;
